import { PlayersList } from "../../../components/player/PlayersList";
import { PlayerShortDto, PlayersFilterBy } from "../../../types/player";
import { TeamContext } from "../../../types/common";
import { FC, useEffect, useState } from "react";
import { getExPlayers } from "../../../api/transport/playersTransport";
import { Loader } from "../../../components/Loader";
import { PageContent } from "../../../components/layout";
import { setDocumentTitle } from "../../../utils";

interface ExPlayersPageProps {
    teamName?: TeamContext;
}

export const ExPlayersPage: FC<ExPlayersPageProps> = ({
    teamName,
}) => {
    const [loading, setLoading] = useState(true);
    const [players, setPlayers] = useState<PlayerShortDto[]>([]);

    useEffect(() => {
        getExPlayers(teamName)
            .then((data) => {
                setPlayers(data);
            })
            .finally(() => {
                setLoading(false);
            });
        setDocumentTitle(`Игроки в других командах - Официальный сайт ФК «Родина»`);
    }, [teamName]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="max-w-[1000px] mx-auto p-2">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">Игроки «Родины» в других командах</h1>
            <PlayersList
                defaultFilter={PlayersFilterBy.Matches}
                players={players as PlayerShortDto[]}
                showTitle
            />
        </div>
    );
};